import { GoogleMap } from '@/modules/google-maps';

if (document.getElementsByTagName('google-map')) {
    customElements.define('google-map', GoogleMap);
}
